import { createBrowserRouter } from 'react-router-dom';
import ErrorComponent from '../Components/ErrorPage/ErrorComponent';
import { PublicOutlet, ProtectedOutlet } from './ProtectedRoutes';
import PublicRoute from '../Routes/PublicRoutes';
import PublicLayout from '../Components/Layouts/Public/PublicLayout';
import PrivateRoute from '../Routes/PrivateRoutes';
import PrivateLayout from '../Components/Layouts/Private/PrivateLayout';
import UnauthorizedComponent from '../Components/UnauthorizePage/Unauthorized';
import RoleGuard from '../Components/RoleGuard/RoleGuard';

const getRoutesConfig = () => {
  // Wrap all private routes with role guard
  const protectedRoutesWithGuards = PrivateRoute.map((route) => ({
    ...route,
    element: <RoleGuard allowedRoles={route.allowedRoles}>{route.element}</RoleGuard>,
  }));

  return createBrowserRouter([
    {
      path: '/',
      element: <PublicOutlet />,
      errorElement: <ErrorComponent />,
      children: [
        {
          element: <PublicLayout />,
          children: PublicRoute,
        },
      ],
    },
    {
      path: '/',
      element: <ProtectedOutlet />,
      errorElement: <ErrorComponent />,
      children: [
        {
          element: <PrivateLayout />,
          children: protectedRoutesWithGuards,
        },
        {
          path: '/unauthorized',
          element: <UnauthorizedComponent />,
        },
      ],
    },
  ]);
};

export default getRoutesConfig;
